enum TrackingInteractionType {
    Answered = "Answered",
    Constructive = "Constructive",
    Positive = "Positive",
    Skipped = "Skipped"
}

export default TrackingInteractionType;
